import { useMemo } from "react";
import { Stack } from "@mui/material";
import { HeatSeries } from "src/store/api/generatedApi";
import { HeatChemistryOverTime } from "./HeatChemistryOverTime";
import { HeatInformationTable } from "./HeatInformationTable";
import { ChemistryElementDropdown } from "./ChemistryElementDropdown";
import { ChemistryElementProvider } from "./ChemistryElementContext";
import { useHeatsData } from "components/strategyDashboard/heats/context/HeatsDataContext";

interface Props {
  heatData: HeatSeries;
}

export const HeatDetailsChemistryTab = ({ heatData }: Props) => {
  const { availableElements } = useHeatsData();

  const elementsWithReadings = useMemo(() => {
    const presentConstraintNames = new Set(
      heatData.samples.flatMap((sample) =>
        sample.values.map((v) => v.constraint_name)
      )
    );
    return availableElements.filter((element) =>
      presentConstraintNames.has(element)
    );
  }, [heatData.samples, availableElements]);

  return (
    <ChemistryElementProvider availableElements={elementsWithReadings}>
      <Stack spacing={2} direction="row" mt={2} flex={1} px={1}>
        <HeatChemistryOverTime heatData={heatData} />
        <Stack spacing={3}>
          <ChemistryElementDropdown />
          <HeatInformationTable heatData={heatData} />
        </Stack>
      </Stack>
    </ChemistryElementProvider>
  );
};
